export enum EventType {
    SearchSubmitted = "SearchSubmitted",
    ResultClicked = "ResultClicked",
}
